import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '@environment';
import { firstValueFrom } from 'rxjs';
import { APP_STORAGE, AppStorage } from '~/app.storage';

@Service()
export class SettingsService {
  private readonly _http = inject(HttpClient);
  private readonly _storage = inject(APP_STORAGE);

  async setPassword(password: string): Promise<void> {
    await firstValueFrom(this._http.post(`${environment.api}/auth/password`, { password }));
    this._storage.removeItem(AppStorage.AccessToken);
  }
}
